export const registerRoute: string = "register";
export const registrationHelpRoute: string = "register/help";

export * from "./registration-shell/registration-shell.component";
export * from "./complete-registration/complete-registration.component";
export * from "./registration-pending/registration-pending.component";
export * from "./help/help.component";